import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { applyRules } from 'components/plays-number/utils';

export const PlaysNumber = ({ plays }) => {
  const { t } = useTranslation();
  return (
    <Fragment>
      {applyRules(plays)} {t('plays')}
    </Fragment>
  );
};

PlaysNumber.propTypes = {
  plays: PropTypes.number.isRequired,
};
